// Elements needed
import {WhitelabelLanguageDetector} from "../../../../common/ts/core/WhitelabelLanguageDetector";
import {EventBus} from "../../../../common/ts/events/EventBus";
import {UserSearchRenderedEvent} from "../../components/userSearch/events";
import {
    ApiGeoResponse,
    AutocompleteResponseEvent,
    GenerateTextSuggestionElementData
} from "../../../../common/ts/events/Events";
import dom from "../../../../common/ts/core/dom";
import {FILTER_NAMES, FILTER_SEARCH_INPUT_SELECTOR} from "./constants";
import location from "../../../../common/ts/core/location";
import {FiltersSubmittedEvent} from "./events";
import tracking from "../../../../common/ts/core/tracking";
import {getFormDataSubmittingInFilterBar} from "./filterFormData";

let autocompleteModalElement: Element | null;
const autocomplete_modal_node = document.querySelectorAll(".autocomplete-modal");
const autocomplete_modal_close_node = document.querySelectorAll(".autocomplete-modal .close")[0];
const autocomplete_field = document.getElementById("search-bar") as HTMLInputElement;
const autocomplete_hidden_geo_id_field = document.getElementById("hidden-geo-id") as HTMLInputElement | null;
const autocomplete_hidden_project_id_field = document.getElementById("hidden-project-id") as HTMLInputElement | null;
const autocomplete_hidden_project_name_field = document.getElementById("hidden-project-name") as HTMLInputElement | null;
const autocomplete_data_list_container = document.getElementById("matched") as HTMLElement;
const autocomplete_field_in_modal = document.getElementById("autocomplete-mobile-input") as HTMLInputElement | null;
const languagePrefix = new WhitelabelLanguageDetector().detectLanguage();
const filtersForm = document.getElementById("filters-form-bar") as HTMLFormElement;
const matched = document.getElementById("matched");
let children : Array<Element> = [];
const textSuggestionCssClass = "text-suggestion";
const textSuggestionTitleCssClass = "text-suggestion-title";
const focusCssClass = "focus";

let eventBus: EventBus;

function init(
    {
        id,
        formId,
        search,
        text,
        geoSlug,
        eb = EventBus.getInstance(),
    }: {
        id: string,
        formId: string,
        search: string,
        text: string,
        geoSlug: string,
        eb?: any,
    }
) {
    const autocompleteSelector = `#${id}`;
    const autocompleteElement = dom.select(autocompleteSelector);
    const autocompleteModalSelector = ".autocomplete-modal";
    autocompleteModalElement = dom.select(autocompleteModalSelector);
    const submitButton = dom.select(`${autocompleteSelector} button[type="submit"]`);
    eventBus = eb;

    EventBus.getInstance().emit(new UserSearchRenderedEvent({
        pathname: search,
        selector:  `form[id="${formId}"]`,
        inputName: 'text',
        text: text,
    }));
    if (!!filtersForm) {
        filtersForm.addEventListener("keypress", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
            }
        });
    }

    let debounce: NodeJS.Timeout;
    let ctr: AbortController | null;
    hideAutocompleteDataList();
    if(!!autocomplete_field){
        if(autocomplete_field.value.length > 2) {
            autocomplete_field!.addEventListener('focus', (e)=>{
                handleChange(e, geoSlug)
            })
        }
        autocomplete_field!.addEventListener('keydown', (e) => {
            if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                handleKeyUp(e);
                return;
            } else if(e.key === "Enter") {
                onSubmit(e);
            }
            if (debounce) {
                clearTimeout(debounce);
            }
            debounce = setTimeout(async () => {
                if (ctr) {
                    ctr.abort();
                }
                const {httpCall, controller}: HandleChangeResponse = handleChange(e, geoSlug);
                ctr = controller;
                await httpCall();
            }, 500);
        });
    }

    submitButton?.addEventListener("click", onSubmit)
    addListenerEventForAutocompleteFieldMobile(autocompleteElement);
    addListenerAutocompleteModalClose();
    moveModalToBodyIfExist();
    window.onclick = function (e) {
        // @ts-ignore
        if (!e.target!.matches('.search-results__options') && e.target.id != 'search-bar') {
            hideAutocompleteDataList();
        }
    }


}

function hideAutocompleteDataList() {
    if(!!autocomplete_data_list_container) {
        autocomplete_data_list_container.style.display = 'none';
    }
}

function showAutocompleteDataList() {
   if(!!autocomplete_data_list_container) {
       autocomplete_data_list_container.style.display = 'flex';
   }

    if (matched != null) {
        children = Array.from(matched.querySelectorAll(`.${textSuggestionCssClass}:not(.${textSuggestionTitleCssClass})`));
    }
}



let focusChildIndex = 0;
function handleKeyUp(event: KeyboardEvent) {
    if (children.length > 0) {
        const focusChild = children.find((child, i) => {
            if (child.classList.contains(focusCssClass)) {
                focusChildIndex = i;
                return true;
            }
            return false;
        }) as HTMLElement | null;
        if (focusChild != null) {
            if (event.key === "ArrowDown") {
                const next = children[focusChildIndex + 1];
                if (next != null && !next!.classList.contains(textSuggestionTitleCssClass)) {
                    next!.classList.add(focusCssClass);
                    focusChild.classList.remove(focusCssClass);
                }
            } else if (event.key === "ArrowUp") {
                const previous = children[focusChildIndex - 1];
                if (previous != null && !previous!.classList.contains(textSuggestionTitleCssClass)) {
                    previous!.classList.add(focusCssClass);
                    focusChild.classList.remove(focusCssClass);
                }
            } else if (event.key === "Enter") {
                focusChild.click();
            }
            focusChild.scrollIntoView({block: "nearest"});
        } else {
            children[0].classList.add(focusCssClass);
        }
    }
}

interface HandleChangeResponse {
    controller: AbortController | null;
    httpCall: () => Promise<any>;
}

// @ts-ignore
function handleChange(e, geoSlug): HandleChangeResponse {
    function removeAllChildNodes(parent: HTMLElement) {
        while (parent.firstChild) {
            parent.removeChild(parent.firstChild)
        }
    }

    // @ts-ignore
    function shouldSendForm(e) {
        return e.target.closest(".search-results__options.auto") !== null;
    }

    function handleClickOption(data: GenerateTextSuggestionElementData, e: Event) {
        const {
            id,
            name,
            completeText,
            isProject,
        } = data;
        autocomplete_field.value = completeText;
        if (!isProject) {
            autocomplete_hidden_geo_id_field!.value = id;
        } else {
            if (autocomplete_hidden_project_id_field != null) {
                autocomplete_hidden_project_id_field.value = id;
            }
            if (autocomplete_hidden_project_name_field != null) {
                autocomplete_hidden_project_name_field.value = name;
            }
        }
        if (shouldSendForm(e)) {
            eventBus.emitMany([
                new FiltersSubmittedEvent({
                    formData: {
                        ...(getFormDataSubmittingInFilterBar()),
                        [FILTER_NAMES.TEXT]: completeText,
                        [FILTER_NAMES.GEO_ID]: id,
                    },
                    searchParams: urlSearchParams(),
                    type: FiltersSubmittedEvent.FORM_TYPE,
                }),
                new tracking.TrackAmplitudeEvent({
                    type: "FiltersUpdated",
                    serpUrl: window.location.href,
                    filters: { location: completeText }
                })
            ]);
        } else {
            if (autocomplete_field_in_modal != null) {
                autocomplete_field_in_modal.value = completeText;
            }
            // @ts-ignore
            removeAllChildNodes(autocomplete_data_list_container);
            handleCloseModal();
        }
    }

    const query: string = e.target.value;
    if (!query.length || query.length < 2) {
        hideAutocompleteDataList();
        removeAllChildNodes(autocomplete_data_list_container)
        return {
            controller: null,
            httpCall: () => Promise.resolve(),
        };
    }
    const controller: AbortController = new AbortController();
    const geoValue = geoSlug.replaceAll("-", " ");
    const geoQuery =(!geoValue || (geoValue && query.toLowerCase().indexOf(geoValue.toLowerCase()) < 0)) ? query : geoValue;
    const url = `${languagePrefix}/api/geo?q=${encodeURIComponent(geoQuery)}`;
    const httpCall: Promise<any> = fetch(url, {signal: controller.signal})
        .then(async (res) => {
            const body: ApiGeoResponse[] = await res.json();
            removeAllChildNodes(autocomplete_data_list_container);
            if (body.length === 0) {
                hideAutocompleteDataList();
                return;
            }
            EventBus.getInstance().emit(new AutocompleteResponseEvent({
                body: body,
                callbacks: {
                    generateTextSuggestionElement: (html: string, data: GenerateTextSuggestionElementData) : void => {
                        const textSuggestionElement = document.createElement('div');
                        textSuggestionElement.innerHTML = html;
                        const node = textSuggestionElement.firstElementChild!;
                        node.addEventListener("click", (e) => {
                            handleClickOption(data, e);
                        });
                        autocomplete_data_list_container.appendChild(node);
                    },
                    insertAdjacentHTML: (html: string) => {
                        autocomplete_data_list_container.insertAdjacentHTML('beforeend', html);
                    },
                    showAutocompleteDataList: showAutocompleteDataList,
                },
                cssClassNames: {
                    textSuggestionCssClass: textSuggestionCssClass,
                    textSuggestionTitleCssClass: textSuggestionTitleCssClass,
                    focusCssClass: focusCssClass,
                }
            }));
        });
    return {
        controller,
        httpCall: () => httpCall,
    };
}

function handleCloseModal() {
    autocompleteModalElement?.classList.remove("show");
    document.body.style.overflow = 'auto';
}

// @ts-ignore
function moveModalToBodyIfExist() {
    if (autocomplete_modal_node != null && autocomplete_modal_node.length > 0) {
        document.body.appendChild(autocomplete_modal_node[0]);
    }
}

// @ts-ignore
function addListenerEventForAutocompleteFieldMobile(autocompleteElement) {
    if (!!autocompleteElement && autocompleteModalElement) {
        autocompleteElement.addEventListener('focusin', () => {
            autocompleteModalElement?.classList.add("show");
            autocomplete_field!.focus()
            document.body.style.overflow = 'hidden';
        })
    }
}

// @ts-ignore
function addListenerAutocompleteModalClose() {
    if (!! autocomplete_modal_close_node) {
        autocomplete_modal_close_node.addEventListener(
            'click',
            handleCloseModal
        )
    }
}

function onSubmit(e: Event) {
    e.preventDefault();
    const searchValue: String = (dom.select(FILTER_SEARCH_INPUT_SELECTOR) as HTMLInputElement).value.toLowerCase()
    const type = FiltersSubmittedEvent.FORM_TYPE;
    eventBus.emit(
        new FiltersSubmittedEvent({
            formData: {
                ...(getFormDataSubmittingInFilterBar()),
                [FILTER_NAMES.GEO_ID]: null,
                [FILTER_NAMES.TEXT]: searchValue,
            },
            searchParams: urlSearchParams(),
            type,
        })
    );
}

function urlSearchParams() {
    return new URLSearchParams(location.getQueryParams());
}

export default {
    init
}
